/**
 * Where staff and couriers are told to go when the app misbehaves in the field
 * (e.g. geolocation reports them away from the shop when they are standing in
 * it). Overridable per-deployment via VITE_SUPPORT_EMAIL so changing the
 * contact does not require a code change.
 */
export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL ?? "giga@flowershopbarcelona.com";
